"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socialMediaFormName = exports.DEFAULT_ICON_URI = void 0;
var _solidUi = require("solid-ui");
var _profileIcons = require("../../icons-svg/profileIcons");
const socialMediaFormName = exports.socialMediaFormName = 'socialMedia.ttl'; // The name of the file to upload

const FALLBACK_ICON_URI = `${_solidUi.icons.iconBase}noun_10636_grey.svg`; // grey disc

const DEFAULT_ICON_URI = exports.DEFAULT_ICON_URI = (() => {
  const svgMarkup = _profileIcons.starIcon?.strings?.join('') || '';
  return svgMarkup ? `data:image/svg+xml;utf8,${encodeURIComponent(svgMarkup)}` : FALLBACK_ICON_URI;
})();